import React from 'react';
import { Badge } from '@/components/ui';

interface Props {
  status: string;
  className?: string;
}

const statusConfig: Record<string, { label: string; color: string }> = {
  scheduled: { label: 'Lên lịch', color: 'bg-slate-100 text-slate-600' },
  active: { label: 'Đang triển khai', color: 'bg-blue-100 text-blue-600' },
  delayed: { label: 'Trễ tiến độ', color: 'bg-rose-100 text-rose-600' },
  completed: { label: 'Hoàn thành', color: 'bg-emerald-100 text-emerald-600' },
  cancelled: { label: 'Hủy bỏ', color: 'bg-slate-200 text-slate-500' },
};

export const ScheduleStatusBadge: React.FC<Props> = ({ status, className }) => {
  const config = statusConfig[status] || { label: status, color: 'bg-slate-100 text-slate-600' };
  
  return (
    <Badge className={`${config.color} border-transparent text-[10px] font-bold ${className}`}>
      {config.label}
    </Badge>
  );
};
